import React, { Component, Fragment } from "react";
import { getConfig, postSubmit } from "../../services/services";
import PunishCard from "../../components/punishCard";
import ProblemDescription from "../../components/problemDescription";
import VerificationCode from "../../components/verificationCode";
import FixedTitle from "../../components/fixedTitle";
import Tips from "../../components/tips";
import ErrorTip from "../../components/errorTip";
import Bounced from "../../components/bounced";
import GeneralButton from "../../components/generalButton";
import UploadVoucher from "../../components/uploadVoucher";
import Loading from "../../components/loading";
import { getQueryString, compare, arrReduce } from "../../utils/utils";
import { burying } from "../../utils/buryPoint";
import { verificationCodeInfo } from "../../services/interfaceType";
import { message } from "antd";
import styles from "./index.less";

interface Props {
  history: any;
  configurationData: any;
  userTypeId?: string;
  enterpriseType?: string;
  customFieldValue?: string | number;
  type?: string;
  getBouncedData?: (text: string) => void;
}
interface State {
  templateData: any;
  submitValue: any;
  contactType: boolean;
  modalType: boolean;
  errorTip: string;
  successBounced: boolean;
  submitData: any;
  codeError: string;
  phoneError: string;
  desError: string;
  docError: string;
  grayType: boolean;
  loading: boolean;
  submit: boolean;
  submitText: string;
}
interface submitValueType {
  fieldName: string; //字段名称
  fieldValue: string; //字段填写内容
  type: string; //字段类型
  showName: string; //字段label名称
  required: boolean; //字段是否必填
}

class Appealentrance extends Component<Props, State> {
  submitValue: any[] = []; //提交数据初始化
  phoneInfo: verificationCodeInfo; //手机号配置
  codeInfo: verificationCodeInfo; //验证码配置
  submitType: boolean = true; //能否提交数据，请求接口
  constructor(props: Props) {
    super(props);
    this.state = {
      templateData: [],
      submitValue: [],
      contactType: false,
      modalType: false,
      errorTip: "",
      successBounced: false,
      submitData: [],
      codeError: "",
      phoneError: "",
      desError: "",
      docError: "",
      grayType: false,
      loading: true,
      submit: true,
      submitText: "申诉提交",
    };
  }

  componentDidMount() {
    const punishId = getQueryString("punishId");
    const { type } = this.props;
    document.body.scrollTop = 0;
    if (type !== "spentrance") {
      this.getGlobleConfig();
      burying(
        "1",
        "appeal-submit-page",
        `punishid=${punishId}`,
        "ss-03",
        "undefined"
      );
    }
  }

  /**
   * @description 文件上传中禁止提交
   *
   **/
  changSubmitStatus = (status) => {
    this.setState({
      submit: status,
    });
  };

  /**
   * @description 获取页面配置数据
   *
   **/
  getGlobleConfig = async () => {
    const templateId = getQueryString("templateId");
    const punishId = getQueryString("punishId");
    const params = {
      templateId,
      punishId: punishId,
    };
    const result = await getConfig(params);
    if (result) {
      if (result.code === 0) {
        this.setState({
          templateData: result.data.widgets.sort(compare("showOrder")),
        });
      } else {
        message.info(result.msg);
      }
      this.setState({
        loading: false,
      });
    } else {
      this.props.history.push("/case/home/error");
    }
  };

  /**
   * @description 获取页面输入组件填写数据
   *
   **/
  getValue = (value: any, type: string) => {
    const arr =
      this.state.submitValue.length > 0
        ? this.state.submitValue
        : this.submitValue;
    const newArr = arrReduce(arr, "fieldName");
    newArr.forEach((item: any) => {
      if (item.fieldName === type) {
        item.fieldValue = value;
      }
    });
    this.setState({
      submitValue: newArr,
    });
    this.inputValidation(type);
  };

  /**
   * @description 清空错误提示
   *
   **/
  inputValidation = (type: string) => {
    switch (type) {
      case "caseDesc":
        this.setState({ desError: "" });
        break;
      case "phone":
        this.setState({ phoneError: "" });
        break;
      case "captcha":
        this.setState({ codeError: "" });
        break;
    }
  };

  /**
   * @description 申诉提交
   *
   **/
  onSubmit = async () => {
    const templateId = getQueryString("templateId");
    const spTemplateId = getQueryString("spTemplateId");
    const punishId = getQueryString("punishId");
    const {
      userTypeId,
      enterpriseType,
      customFieldValue,
      type,
      getBouncedData,
    } = this.props;
    const { submitValue, submit } = this.state;
    const submitValueFinish: { fieldName: string; fieldValue: string }[] = [];
    if (!submit) {
      message.info("文件上传中 请稍等!");
      return;
    }
    if (submitValue.length === 0) {
      message.info("您未提交任何内容");
      return;
    }
    this.onCheckAll();
    submitValue.forEach((item: submitValueType) => {
      submitValueFinish.push({
        fieldName: item.fieldName,
        fieldValue: item.fieldValue,
      });
    });
    const params = {
      templateId: templateId === "undefined" ? "" : templateId,
      punishId: punishId,
      param: JSON.stringify(submitValueFinish),
      spTemplateId: spTemplateId,
      userType: userTypeId,
      enterpriseType: enterpriseType,
      customFieldValue: customFieldValue,
    };
    if (this.submitType) {
      this.setState({
        submitText: "提交中...",
      });
      const result = await postSubmit(params);
      if (result) {
        this.setState({
          submitText: "申诉提交",
        });
        if (result.code === 0) {
          this.setState({
            submitData: result.data,
            grayType: true,
          });
          if (type == "spentrance") {
            getBouncedData(result.data.text);
          }
          // 提交成功
          this.setState({
            successBounced: !this.state.successBounced,
          });
        } else {
          message.info(result.msg);
        }
      } else {
        this.props.history.push("/case/home/error");
      }
      burying(
        "2",
        "submit-appeal-submit",
        `valid=1$punishid=${punishId}`,
        "ss-03",
        "undefined"
      );
    } else {
      burying(
        "2",
        "submit-appeal-submit",
        `valid=0$punishid=${punishId}`,
        "ss-03",
        "undefined"
      );
    }
  };

  onCheckAll = async () => {
    const { submitValue, contactType } = this.state;
    let submit = true,
      phoneNum = "";
    submitValue.forEach((item: submitValueType) => {
      if (contactType && item.fieldName === "phone" && item.fieldValue !== "") {
        phoneNum = item.fieldValue;
        const regPhoneNum = /^1[3456789]\d{9}$/; // 手机号
        if (!regPhoneNum.test(item.fieldValue)) {
          this.setState({
            phoneError: "请输入正确的手机号",
          });
          submit = false;
        }
      }
      if (
        phoneNum !== "" &&
        contactType &&
        item.fieldName === "captcha" &&
        item.fieldValue === ""
      ) {
        this.setState({
          codeError: "请输入验证码！",
        });
        submit = false;
      }
      if (
        item.required &&
        (item.fieldValue === "" || item.fieldValue.length === 0)
      ) {
        if (item.fieldName !== "phone" && item.fieldName !== "captcha") {
          item.type == "4" || item.type == "5"
            ? this.setState({
              docError: `请${item.showName}`,
            })
            : this.setState({
              desError: `请输入${item.showName}`,
            });
          submit = false;
        }
        if (contactType) {
          if (item.fieldName === "phone") {
            this.setState({
              phoneError: `请输入${item.showName}`,
            });
          }
          if (item.fieldName === "captcha") {
            this.setState({
              codeError: `请输入${item.showName}`,
            });
          }
          submit = false;
        }
      }
    });
    this.submitType = submit;
  };

  /**
   * @description 修改手机号，控制组件展示
   *
   **/
  onChangePhone = (fields: any) => () => {
    const punishId = getQueryString("punishId");
    if (fields) {
      this.setState({
        contactType: true,
      });
    } else {
      this.setState({
        errorTip: "暂无配置信息",
      });
    }
    burying(
      "2",
      "modify-mobile-submit",
      `punishid=${punishId}`,
      "ss-03",
      "undefined"
    );
  };

  /**
   * @description 关闭弹框
   *
   **/
  cancelBounced = () => {
    const { successBounced } = this.state;
    this.setState({
      successBounced: !successBounced,
    });
    document.getElementById("container").style.overflowY = 'scroll'
  };

  /**
   * @description 跳转到申诉列表页
   *
   **/
  linkToAppealList = () => {
    const templateId = getQueryString("templateId");
    const punishId = getQueryString("punishId");
    this.props.history.push(`/case/home/list?templateId=${templateId}`);
    burying(
      "2",
      "flow-appeal-submit",
      `button=1$punishid=${punishId}`,
      "ss-03",
      "undefined"
    );
  };

  /**
   * @description 跳转到处罚列表页
   *
   **/
  linkToPenaltyList = () => {
    const templateId = getQueryString("templateId");
    const punishId = getQueryString("punishId");
    this.props.history.push(`/case/home/punish/list?templateId=${templateId}`);
    burying(
      "2",
      "flow-appeal-submit",
      `button=0$punishid=${punishId}`,
      "ss-03",
      "undefined"
    );
  };

  /**
   * @description 根据配置数据渲染组件
   *
   **/
  configureComponent = (templateData: any) =>
    templateData.map((item: any, index: number) => {
      const { widgetType, widgetJSON, widgetTips, fields } = item;
      switch (widgetType) {
        case 1:
          return (
            <div key={index} className={styles.inputComponents}>
              {this.inputComponents(fields.sort(compare("showOrder")))}
            </div>
          );
        case 2:
          return (
            <div className={styles.punishDetai} key={index}>
              <FixedTitle fixedTitle={widgetTips} />
              <PunishCard punishDetails={widgetJSON.punishDetails} />
            </div>
          );
        case 3:
          return (
            <div key={index} className={styles.ordinaryTipBox}>
              <FixedTitle fixedTitle={widgetTips} />
              <Tips type="ordinary" promptList={widgetJSON} />
            </div>
          );
        case 4:
          return (
            <div key={index} className={styles.tipBox}>
              <Tips type="special" promptList={widgetJSON} />
            </div>
          );
        case 5:
          return (
            <div key={index} className={styles.phoneComponent}>
              <FixedTitle fixedTitle={widgetTips} />
              {this.phoneComponent(widgetJSON.defaultPhone, fields)}
            </div>
          );
        default:
          return null;
      }
    });

  /**
   * @description 手机号验证码组件
   *
   **/
  phoneComponent = (defaultPhone: string, fields: any) => {
    let { contactType, errorTip, codeError, phoneError, grayType } = this.state;
    if (!contactType && fields) {
      fields.forEach((item: any) => {
        this.submitValue.push({
          fieldName: item.fieldName,
          fieldValue: "",
          type: item.type.toString(),
          showName: item.showName,
          required: item.required,
        });
        item.fieldName === "phone" ? (this.phoneInfo = item) : "";
        item.fieldName === "captcha" ? (this.codeInfo = item) : "";
      });
    }
    if (contactType || defaultPhone === undefined || !fields) {
      return (
        <VerificationCode
          phoneInfo={this.phoneInfo}
          codeInfo={this.codeInfo}
          code={true}
          getValue={this.getValue}
          codeError={codeError}
          phoneError={phoneError}
          grayType={grayType}
        />
      );
    } else {
      return (
        <React.Fragment>
          <div className={styles.defaultPhoneStyle}>
            <div className={styles.defaultPhoneNUmber}>
              <span>手机号码：</span>
              <span>{defaultPhone}</span>
            </div>
            <span
              className={styles.changeNum}
              style={{ pointerEvents: grayType ? "none" : null }}
              onClick={this.onChangePhone(fields)}
            >
              <em>修改绑定手机</em>
              <em>{">"}</em>
            </span>
          </div>
          {errorTip ? <ErrorTip errorTip={errorTip} /> : null}
        </React.Fragment>
      );
    }
  };

  /**
   * @description 输入类型组件
   *
   **/
  inputComponents = (fields: any) => {
    const { desError, docError, grayType } = this.state;
    return fields.map((item: any, index: number) => {
      const { type, showName, fieldName, required, showTips, maxSize } = item;
      this.submitValue.push({
        fieldName: fieldName,
        fieldValue: "",
        type: type,
        showName: showName,
        required: required,
      });
      switch (type) {
        case 2:
          return (
            <div key={index}>
              <ProblemDescription
                labelName={showName}
                fieldName={fieldName}
                is_required={required}
                placeholder={showTips}
                maxSize={maxSize}
                errorTip={desError}
                getValue={this.getValue}
                grayType={grayType}
              />
            </div>
          );
        case 4:
          return (
            <div
              key={index}
              style={{
                borderBottom:
                  index === fields.length - 1 ? "1px solid #E6E6E6" : "",
              }}
            >
              <UploadVoucher
                labelName={showName}
                fieldName={fieldName}
                is_required={required}
                showTips={showTips}
                maxSize={maxSize}
                errorTip={docError}
                getValue={this.getValue}
                grayType={grayType}
                reference={index === fields.length - 1 ? false : true}
                changSubmitStatus={this.changSubmitStatus}
              />
            </div>
          );
        case 5:
          return (
            <div
              key={index}
              style={{
                borderBottom:
                  index === fields.length - 1 ? "1px solid #E6E6E6" : "",
              }}
            >
              <UploadVoucher
                labelName={showName}
                fieldName={fieldName}
                is_required={required}
                showTips={showTips}
                maxSize={maxSize}
                errorTip={docError}
                getValue={this.getValue}
                grayType={grayType}
                reference={index === fields.length - 1 ? false : true}
                changSubmitStatus={this.changSubmitStatus}
              />
            </div>
          );
        default:
          return null;
      }
    });
  };

  render() {
    const {
      templateData,
      successBounced,
      submitData,
      grayType,
      loading,
      submitText,
    } = this.state;
    const { configurationData, type } = this.props;
    const templateId = getQueryString("templateId");
    return (
      <Fragment>
        {type !== "spentrance" && successBounced ? (
          <div className={styles.bounced} >
            <Bounced
              bouncedText={submitData.text}
              needImg={true}
              cancelBounced={this.linkToPenaltyList}
              confirm={this.linkToAppealList}
              goBack={this.linkToPenaltyList}
              buttonLeft="返回"
              buttonRight="申诉记录"
            />
          </div>
        ) : null}
        <div style={{ width: templateId === "2" ? "" : "815px" }}>
          <div
            className={
              type === "spentrance" ? styles.spentrance : styles.appealentrance
            }
          >
            {type === "spentrance" ? null : (
              <div className={styles.punishTitle}>
                <span className={styles.name}>提交申诉</span>
              </div>
            )}
            {loading && type !== "spentrance" ? (
              <Loading />
            ) : (
              <Fragment>
                {this.configureComponent(
                  configurationData ? configurationData : templateData
                )}
                <div className={styles.submitButton}>
                  <GeneralButton
                    buttonText={submitText}
                    type="middle"
                    styleColor="activation"
                    buttonClick={this.onSubmit}
                    grayType={grayType}
                  />
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Appealentrance;
